module.exports = __webpack_public_path__ + "static/media/elipsis-horizontal.95ba50a4.svg";